import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { login } from "@/models/login/api/login";
import { Toast } from "@/views/components/Toast";
import type { BaseResponse } from "@/models/common/types/BaseResponse";

export const useLogin = () => {
  const { data, error, isError, isSuccess, isPending, mutateAsync, mutate } =
    useMutation({
      mutationFn: login,
      onError: (error: AxiosError<BaseResponse<null>>) => {
        Toast({
          title: error.response?.data.message,
          text: "",
          type: "error",
        });
      },
      async onSuccess(data) {
        Toast({
          title: "Selamat datang di Billing Dashboard",
          text: "",
          type: "success",
        });

        // Fetch user profile and await the response
        const res = await fetch(
          `${process.env.NEXT_PUBLIC_API_URL}/klikoo-billing/user/profile`,
          {
            headers: {
              Authorization: `Bearer ${data?.data?.data?.access_token}`,
            },
          },
        );

        // Parse and await the JSON response
        const item = await res.json();

        // Set auth cookies via API route to ensure server-side cookie setting
        await fetch("/api/set-auth-cookies", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({
            token: data?.data?.data?.access_token,
            company_id: item.data?.company?.id,
            username: item.data?.name,
          }),
        });

        // Set username in localStorage (client-side only)
        if (typeof window !== "undefined") {
          window.localStorage.setItem("username", item.data?.name);
        }

        // Force full page reload to ensure middleware runs with new cookies
        window.location.href = "/";
      },
    });

  return {
    isSuccess,
    isError,
    isPending,
    data,
    error,
    mutateAsync,
    mutate,
  };
};
